import { useHistory } from "react-router-dom";
import { Loader } from "@monorepo/components";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useClientInfoQuery } from "@monorepo/services/api/auth";
import theme from "@monorepo/styles/theme";
import { Box, ListItem, styled, Typography } from "@mui/material";
import { reverse } from "named-urls";

import { GsmVoucherVendorIcon } from "./GsmVoucherVendorIcon";

export const VouchersListItem = styled(ListItem)(() => ({
  display: "flex",
  alignItems: "center",
  columnGap: theme.spacing(2),
  cursor: "pointer",
  padding: "12px",
  borderRadius: "12px",
  backgroundColor: "inherit",
  color: "inherit",
  "&:hover": {
    color: theme.palette.secondary.main,
    background: theme.palette.card.dark,
    "& svg": {
      background: "white",
    },
  },
}));

export const GsmVoucherVendorsList = () => {
  const history = useHistory();
  const { data: clientInfo, isLoading } = useClientInfoQuery({ skipInitialLoad: true });
  const vendors = clientInfo?.evoucher_providers;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Box>
        {vendors?.map((vendor) => {
          return (
            <VouchersListItem
              role="presentation"
              tabIndex={-1}
              key={vendor}
              onClick={() =>
                history.push(
                  reverse(routeConfig.dashboard.services.gsmVouchers.buyGsmVoucher.vendor.self, {
                    vendor: vendor,
                  })
                )
              }
            >
              <GsmVoucherVendorIcon vendor={vendor} />
              <Typography component="span">{vendor}</Typography>
            </VouchersListItem>
          );
        })}
      </Box>
    </>
  );
};

export default GsmVoucherVendorsList;
